module.exports = __webpack_public_path__ + "static/media/IMG-21.cc2f5911.jpg";